import React, { useState } from "react";
import { COLORS } from "utils/styles";
import { getIconForUID } from "components/FormerEditor/utils";
import classnames from "classnames";
import { useHoverProps } from "utils/hooks";

const DEFAULT_CLASSES = {
  container: "pa3 bg-white pointer w-100",
  content: "flex flex-row justify-between items-center",
  option: "f5"
};

const ModelOption = ({ isLast, isActive, onClick, model, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const [hover, setHover] = useState(false);
  const hoverProps = useHoverProps({ hover, setHover });

  const Icon = getIconForUID("checkmark");

  const containerProps = {
    className: classnames(classes.container, {
      "bb hairline-1": !isLast,
      "bg-white": !hover || isActive,
      "bg-content--secondary": hover && !isActive,
      "fw5": isActive
    }),

    ...hoverProps
  };
  if (!model.disabled) {
    containerProps.onClick = () => {
      onClick(model.id);
    };
  }
  let icon;

  if (isActive || hover) {
    const color = isActive ? COLORS.blue : COLORS.deselected;
    icon = <Icon size={16} color={color} />;
  }
  return (
    <div {...containerProps}>
      <div className={classes.content}>
        <div className={classnames(classes.option, { fw5: isActive })}>
          {model.name}
        </div>
        {icon}
      </div>
    </div>
  );
};

export default ModelOption;
